/* tslint:disable */

declare var Object: any;
export interface PayrollHistoryServiceInterface {
  "id"?: number;
}

export class PayrollHistoryService implements PayrollHistoryServiceInterface {
  "id": number;
  constructor(data?: PayrollHistoryServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PayrollHistoryService`.
   */
  public static getModelName() {
    return "PayrollHistoryService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PayrollHistoryService for dynamic purposes.
  **/
  public static factory(data: PayrollHistoryServiceInterface): PayrollHistoryService{
    return new PayrollHistoryService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PayrollHistoryService',
      plural: 'PayrollHistoryServices',
      path: 'PayrollHistoryServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/PayrollHistoryService.ts